import instance from '../utils/axiosConfig';
import { getToken } from '../utils/auth';
import { auth } from '../utils/auth';
import LdPlaceholder from '../assets/ldplaceholder.png';
import LiderdistBanner from '../assets/CatalogBanner.jpg';
// Mock data for testing without backend
const mockDistributor = {
  _id: 'mock-distributor-1',
  name: 'Distribuidor de Prueba',
  governmentName: 'Razón Social de Prueba',
  description: 'Este es un distribuidor de prueba para desarrollo frontend.',
  email: 'test@distributor.com',
  phone: '1234567890',
  status: 'verified',
  zones: ['Zona Norte', 'Zona Sur', 'Zona Centro','Zona Oeste'],
  city: 'Ciudad de Prueba',
  province: 'Provincia de Prueba',
  country: 'AR',
  bannerImage: LiderdistBanner,
  profileImage: LdPlaceholder,
  externalUrls: ['https://drive.google.com/file/d/1234567890/view']
};

const mockProducts = [
  {
    _id: 'mock-product-1',
    name: 'Producto de Prueba 1',
    description: 'Descripción del producto de prueba 1',
    category: 'Alimentos',
    basePrice: 1000,
    unit: 'UNIT',
    mainImage: LdPlaceholder,
    priceBreaks: [
      { minQuantity: 10, price: 900 },
      { minQuantity: 50, price: 800 }
    ],
    unit: 'unidad',
    createdAt: new Date().toISOString(),
    views: 100
  },
  {
    _id: 'mock-product-2',
    name: 'Producto de Prueba 2 Nombre Largo',
    description: 'Descripción del producto de prueba 2',
    category: 'Bebidas',
    basePrice: 500,
    unit: 'UNIT',
    mainImage: LdPlaceholder,
    priceBreaks: [
      { minQuantity: 5, price: 4500000 },
      { minQuantity: 20, price: 400 }
    ],
    unit: 'unidad',
    createdAt: new Date().toISOString(),
    views: 50
  }
];

export const api = {
  // Auth
  registerBusiness: async (data) => {
    try {
      const country = window.location.pathname.split('/')[1] || 'ar';
      const response = await instance.post('/api/auth/register-business', {
        name: data.name,
        razonSocial: data.legalName,
        CUIT: data.taxId,
        address: data.contactInfo.address,
        zone: data.zone,
        email: data.email,
        password: data.password,
        phone: data.contactInfo.phone,
        country: data.country
      });
      return response.data;
    } catch (error) {
      console.warn('Using mock data - registerBusiness');
      return { success: true, message: 'Mock registration successful' };
    }
  },

  verifyEmail: async (token) => {
    const response = await instance.post(`/api/auth/verify-email/${token}`);
    return response.data;
  },

  registerDistributor: async (data) => {
    const response = await instance.post('/api/auth/register-distributor', {
      name: data.name,
      governmentName: data.legalName,
      CUIT: data.taxId,
      description: data.description,
      email: data.email,
      password: data.password,
      address: data.contactInfo.address,
      phone: data.contactInfo.phone,
      zones: data.zones,
      country: data.country,
      province: data.province,
      city: data.city
    });
    return response.data;
  },

  login: async (credentials) => {
    const response = await instance.post('/api/auth/login', credentials);
    return response.data;
  },

  changePassword: async (currentPassword, newPassword) => {
    try {
        const response = await instance.post('/api/auth/change-password', {
            currentPassword,
            newPassword
        }, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        
        // Handle success
        return response.data;
    } catch (error) {
        // Handle error
        throw error.response.data;
    }
  },

  // Products
  getProducts: async (filters = {}) => {
    try {
      const country = window.location.pathname.split('/')[1] || 'ar';
      const response = await instance.get('/api/products', { 
        params: { ...filters, country: country.toUpperCase() }
      });
      return response.data || mockProducts; // Fallback to mock data if empty
    } catch (error) {
      console.warn('Using mock data - getProducts');
      return mockProducts;
    }
  },

  getProduct: async (id) => {
    try {
      const response = await instance.get(`/api/products/${id}`);
      return response.data || mockProducts[0]; // Fallback to first mock product if empty
    } catch (error) {
      console.warn('Using mock data - getProduct');
      return mockProducts[0];
    }
  },

  createProduct: async (productData) => {
    const response = await instance.post('/api/products', productData);
    return response.data;
  },

  updateProduct: async (id, productData) => {
    const response = await instance.put(`/api/products/${id}`, productData);
    return response.data;
  },

  deleteProduct: async (id) => {
    const response = await instance.delete(`/api/products/${id}`);
    return response.data;
  },

  // Distributors
  getDistributors: async (filters = {}) => {
    try {
      const country = window.location.pathname.split('/')[1] || 'ar';
      const response = await instance.get('/api/distributors', { 
        params: { ...filters, country: country.toUpperCase() }
      });
      return response.data || [mockDistributor]; // Fallback to mock distributor if empty
    } catch (error) {
      console.warn('Using mock data - getDistributors');
      return [mockDistributor];
    }
  },

  getDistributor: async (id) => {
    try {
      const response = await instance.get(`/api/distributors/${id}`);
      return response.data || mockDistributor; // Fallback to mock distributor if empty
    } catch (error) {
      console.warn('Using mock data - getDistributor');
      return mockDistributor;
    }
  },

  updateDistributorProfile: async (id, profileData) => {
    try {
      const response = await instance.patch(`/api/distributors/${id}`, profileData);
      return response.data;
    } catch (error) {
      console.error('Error updating distributor profile:', error);
      throw error;
    }
  },

  getDistributorProducts: async (id) => {
    try {
      const response = await instance.get(`/api/distributors/${id}/products`);
      return response.data || mockProducts; // Fallback to mock products if empty
    } catch (error) {
      console.warn('Using mock data - getDistributorProducts');
      return mockProducts;
    }
  },

  // Business
  getBusinessProfile: async () => {
    try {
      const response = await instance.get('/api/business/profile');
      return response.data;
    } catch (error) {
      console.error('Error getting business profile:', error);
      throw error;
    }
  },

  updateBusinessProfile: async (profileData) => {
    try {
      const response = await instance.put('/api/business/profile', profileData);
      return response.data;
    } catch (error) {
      console.error('Error updating business profile:', error);
      throw error;
    }
  },

  // Zones
  getZones: async () => {
    const response = await instance.get('/api/zones');
    return response.data;
  },

  getZone: async (id) => {
    const response = await instance.get(`/api/zones/${id}`);
    return response.data;
  },

  getDistributorProfile: async () => {
    try {
      const response = await instance.get('/api/distributors/profile');
      return response.data;
    } catch (error) {
      console.error('Error getting distributor profile:', error);
      throw error;
    }
  },

  getSubUserProfile: async () => {
    try {
      if (auth.getUser().permissions?.canEditDistributorInfo) {
        const response = await instance.get('/api/distributors/profile');
        return response.data;
      } else {
        throw new Error('No tienes permisos para ver este perfil');
      }
    } catch (error) {
      console.error('Error getting sub-user profile:', error);
      throw error;
    }
  },

  // Add country detection
  detectCountry: async () => {
    const response = await instance.get('/api/detect-country');
    return response.data;
  },

  deleteBusinessProfile: () => {
    return instance.delete('/api/business/profile');
  },

  deleteDistributorProfile: () => {
    return instance.delete('/api/distributors/profile');
  },

  uploadProfileImage: async (formData) => {
    const response = await instance.post('/api/upload/profile-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateBusinessProfile: async (profileData) => {
    const response = await instance.put('/api/business/profile', profileData);
    return response.data;
  },

  updateDistributorProfile: async (id, profileData) => {
    const response = await instance.patch(`/api/distributors/${id}`, profileData);
    return response.data;
  },

  forgotPassword: async (email) => {
    const response = await instance.post('/api/auth/forgot-password', { email });
    return response.data;
  },

  resendVerificationEmail: () => {
    return instance.post('/api/auth/resend-verification');
  },

  resetPassword: async (token, password) => {
    const response = await instance.post(`/api/auth/reset-password/${token}`, { password });
    return response.data;
  },

  // Sub-users
  getSubUsers: async () => {
    const response = await instance.get('/api/sub-users');
    return response.data;
  },

  createSubUser: async (userData) => {
    const response = await instance.post('/api/sub-users', userData);
    return response.data;
  },

  updateSubUser: async (id, userData) => {
    const response = await instance.put(`/api/sub-users/${id}`, userData);
    return response.data;
  },

  deleteSubUser: async (id) => {
    const response = await instance.delete(`/api/sub-users/${id}`);
    return response.data;
  },

  subUserLogin: async (credentials) => {
    const response = await instance.post('/api/sub-users/login', credentials);
    return response.data;
  },

  // Add this to the api object
  getCategoriesWithCounts: async () => {
    try {
      const response = await instance.get('/api/products/categories/count');
      return response.data;
    } catch (error) {
      console.warn('Error fetching category counts:', error);
      return [];
    }
  },
};